import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Form, Input, Modal, Radio } from "antd";
import { axiosErrorHandler, showSuccessNotification } from "../../../../swzutils";
import { CustomerContactType, } from "./api/Representation";
import { validateEmail } from "../../../../swzutils/ValidationUtil";
import CustomerContactResource from "./api/CustomerContactResource";
const CustomerContactUpdateModal = ({ customerId, customerContact, open, canChangeContactType, defaultCustomerContactType, onCancel, onSave }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [customerContactType, setCustomerContactType] = useState(defaultCustomerContactType || CustomerContactType.OFFICE);
    useEffect(() => {
        if (customerContact) {
            populateFormFields(customerContact);
        }
        else {
            form.resetFields();
            if (defaultCustomerContactType) {
                setCustomerContactType(defaultCustomerContactType);
            }
        }
    }, [customerContact, defaultCustomerContactType]);
    const populateFormFields = (customerContact) => {
        form.setFieldsValue({
            "firstName": customerContact.firstName,
            "lastName": customerContact.lastName,
            "emailAddress": customerContact.emailAddress,
            "telephone": customerContact.telephone,
            "position": customerContact.position,
            "customerContactType": customerContact.type,
        });
        setCustomerContactType(customerContact.type);
    };
    const notifySuccess = (contact, action) => {
        const fullName = contact.lastName ? `${contact.firstName} ${contact.lastName}` : contact.firstName;
        showSuccessNotification(`Customer contact ${fullName} ${action}`);
        onSave(contact);
    };
    const onFinish = (formValues) => {
        setLoading(true);
        const request = {
            firstName: formValues.firstName,
            lastName: formValues.lastName,
            emailAddress: formValues.emailAddress,
            telephone: formValues.telephone,
            position: formValues.position,
            version: customerContact?.version,
            type: formValues.customerContactType || customerContact?.type || customerContactType
        };
        if (customerContact) {
            CustomerContactResource.update(customerId, customerContact.id, request, updated => notifySuccess(updated, "updated"), axiosErrorHandler, () => setLoading(false));
        }
        else {
            CustomerContactResource.create(customerId, request, updated => notifySuccess(updated, "created"), axiosErrorHandler, () => setLoading(false));
        }
    };
    const editMode = !!(customerContact && customerContact.id);
    return (_jsx(Modal, { title: editMode ? "Edit customer contact" : "Create new customer contact", open: open, confirmLoading: loading, onOk: form.submit, onCancel: onCancel, destroyOnHidden: true, children: _jsxs(Form, { layout: "vertical", form: form, onFinish: onFinish, children: [canChangeContactType &&
                    _jsx(Form.Item, { name: "customerContactType", initialValue: customerContactType, children: _jsxs(Radio.Group, { buttonStyle: "solid", onChange: e => setCustomerContactType(e.target.value), children: [_jsx(Radio.Button, { value: CustomerContactType.OFFICE, children: "Office / General" }, CustomerContactType.OFFICE), _jsx(Radio.Button, { value: CustomerContactType.DRIVER, children: "Driver" }, CustomerContactType.DRIVER)] }) }), _jsx(Form.Item, { name: "firstName", label: "First Name", rules: [
                        { required: true, message: 'First name is required' },
                        { max: 50, message: 'Please limit to 50 characters.' }
                    ], children: _jsx(Input, { maxLength: 50 }) }), _jsx(Form.Item, { name: "lastName", label: "Last name", rules: [
                        { max: 50, message: 'Please limit to 50 characters.' }
                    ], children: _jsx(Input, { maxLength: 50 }) }), _jsx(Form.Item, { name: "emailAddress", label: "Email address", rules: [
                        { required: customerContactType === CustomerContactType.OFFICE, message: 'First name is required' },
                        { max: 255, message: 'Please limit to 255 characters.' },
                        { validator: validateEmail }
                    ], children: _jsx(Input, { maxLength: 255 }) }), _jsx(Form.Item, { name: "telephone", label: "Telephone", rules: [
                        { required: true, message: 'Telephone is required' },
                        { max: 50, message: 'Please limit to 50 characters.' }
                    ], children: _jsx(Input, { maxLength: 50 }) }), customerContactType === CustomerContactType.OFFICE &&
                    _jsx(Form.Item, { name: "position", label: "Position", rules: [
                            { max: 255, message: 'Please limit to 255 characters.' }
                        ], children: _jsx(Input, { maxLength: 255 }) })] }) }));
};
export default CustomerContactUpdateModal;
